import { createEntityAdapter } from "@reduxjs/toolkit";
import type { DomainDriverModuleEntryV2 } from "@exopengithub/planning-api-shared";

export const driverModuleEntriesV2Adapter =
	createEntityAdapter<DomainDriverModuleEntryV2>();

export const driverModuleEntriesV2Selectors =
	driverModuleEntriesV2Adapter.getSelectors();
